import { render, staticRenderFns } from "./personalcode.vue?vue&type=template&id=1ab13da9"
import script from "./personalcode.vue?vue&type=script&lang=js"
export * from "./personalcode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports